import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "t-table" }
const _hoisted_2 = { width: "20%" }
const _hoisted_3 = { width: "30%" }
const _hoisted_4 = { width: "25%" }
const _hoisted_5 = {
  width: "25%",
  class: "t-table-data"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icf-info" }, null, -1)
const _hoisted_7 = ["data-qe-id"]
const _hoisted_8 = ["rowspan"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icf-arrowBottom" }, null, -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 1,
  class: "no-results",
  "data-qe-id": "no-results-available-row"
}

import { TicketGroup } from '@/store/modules/ranking/season'
import { SeasonRanking } from '@/model/ranking/Season'
import CTicketIcon from '@/components/CTicketIcon.vue'

const COLSPAN_NUM = 4


export default /*#__PURE__*/_defineComponent({
  __name: 'CTicketTable',
  props: {
    data: {},
    maxRows: {},
    myRank: {},
    isSearchActive: { type: Boolean }
  },
  emits: ['show-more'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
function isMyUser(user: SeasonRanking) {
  return user.playerId === props.myRank.playerId
}

function onShowMore() {
  emit('show-more')
}

return (_ctx: any,_cache: any) => {
  const _component_t_tooltip = _resolveComponent("t-tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.$t('table.columns.tournament')), 1),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.$t('table.columns.playerName')), 1),
        _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('table.columns.score')), 1),
        _createElementVNode("td", _hoisted_5, [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('table.columns.ticket')) + " ", 1),
            _createVNode(_component_t_tooltip, {
              class: "tooltip",
              text: _ctx.$t('table.info.ticket')
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["text"])
          ])
        ])
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_ctx.data.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (tournament, tindex) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (tournament.seasonRankings.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(tournament.seasonRankings, (user, uindex) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass({ 'table-row-odd': tindex % 2 }),
                        key: user.playerId,
                        "data-qe-id": `tr-data--tournament_${tindex}--user_${uindex}${isMyUser(user) ? '--highlighted' : ''}`
                      }, [
                        (uindex === 0)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              rowspan: tournament.seasonRankings.length
                            }, _toDisplayString(tournament.tournamentName), 9, _hoisted_8))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", {
                          class: _normalizeClass({ highlighted: isMyUser(user) }),
                          "data-qe-id": "playername"
                        }, _toDisplayString(user.playerName), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass({ highlighted: isMyUser(user) }),
                          "data-qe-id": "score"
                        }, _toDisplayString(user.ticketInfo.tournamentScore), 3),
                        _createElementVNode("td", {
                          class: _normalizeClass({ highlighted: isMyUser(user) })
                        }, [
                          _createVNode(CTicketIcon)
                        ], 2)
                      ], 10, _hoisted_7))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (_ctx.maxRows > _ctx.data.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                  _createElementVNode("td", {
                    class: "show-more-row",
                    colspan: COLSPAN_NUM,
                    onClick: onShowMore,
                    "data-qe-id": "show-more-link"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('table.more.button')) + " ", 1),
                    _hoisted_10
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSearchActive && _ctx.data.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                  _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.search.results_not_found')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("tr", _hoisted_12, [
            _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.more.no_results')), 1)
          ]))
    ])
  ]))
}
}

})